import React, { ChangeEvent, Dispatch, useRef, useState } from "react";
import { GetFeedbackType, InitialMessage, MessageAutoManager } from "../../Validations/Common";
import { Form } from "react-bootstrap";
import { FloatingCheckProps, FloatingCheckValue } from "../../@types/Rd";
import "./Styles.scss";

type FloatingCheckValidationEditSet = {
    ValidationHandle?: (value: FloatingCheckValue) => string[],
    setValueCache: React.Dispatch<React.SetStateAction<FloatingCheckValue>>,
    setValidations: Dispatch<React.SetStateAction<string[]>>,
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>
}

type FloatingCheckValueHandleType = {
    value: FloatingCheckValue,
    valueHandle?: (value: FloatingCheckValue, isValid: boolean) => void,
    el?: HTMLInputElement,
    editSet: FloatingCheckValidationEditSet
}

const ProcessValue = ({ value, valueHandle, editSet }: FloatingCheckValueHandleType): void => {
    const validations: string[] = (editSet.ValidationHandle != null && editSet.ValidationHandle(value)) || [],
        isValid: boolean = !validations.some(x => x),
        message: string = (validations.some(x => x) && validations.join("\n")) || InitialMessage(isValid);

    editSet.setValidations(validations);
    editSet.setIsValid(prev => (prev == isValid && prev) || isValid);
    editSet.setMessage(message);
    editSet.setValueCache(value)
    valueHandle && valueHandle(value, isValid);
}

const HandleInitialValue = (initialValue: FloatingCheckValue, value: FloatingCheckValue): FloatingCheckValue => {

    if (typeof initialValue == "number" && initialValue == 0)
        return initialValue;

    if (typeof value == "number" && value == 0)
        return value;

    return initialValue || value || "";

}

const FloatingCheck = ({ id, validation, label, valueHandle, group, checkRef, required, type, initialValue, isAutoManaged, ...rest }: FloatingCheckProps): JSX.Element => {

    if (group == null)
        group = { controlId: `${id}Validation` };
    else if (id != null && id != "" && (group.controlId == null || group.controlId == ""))
        group.controlId = `${id}Validation`;

    if (type == null)
        type = "checkbox";

    checkRef = checkRef || useRef<HTMLInputElement>(null);

    const [valueCache, setValueCache] = useState<FloatingCheckValue>(HandleInitialValue(initialValue, rest.value)),
        [validations, setValidations] = validation?.validationsState || useState<string[]>([]),
        [isValid, setIsValid] = validation?.isValidState || useState<boolean>(!validations.some(x => x)),
        [message, setMessage] = validation?.messageState || useState<string>(InitialMessage(isValid)),
        editSet: FloatingCheckValidationEditSet = { setIsValid, setMessage, setValidations, setValueCache, ValidationHandle: validation?.ValidationHandle };

    return (
        <Form.Group {...group}>
            <Form.FloatingLabel controlId={`chk${id}`} label="">
                <Form.Check
                    ref={checkRef}
                    isInvalid={(validation != null && !isValid) || undefined}
                    isValid={(validation != null && isValid) || undefined}
                    type={type}
                    required={required}
                    value={valueCache}
                    checked={/true|1/.test(valueCache as string)}
                    label={label.replace(":", "")}
                    aria-label={label.replace(":", "")}
                    feedbackTooltip
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const { target: { checked }, } = event;
                        ProcessValue({ value: checked as unknown as string, valueHandle, editSet, el: event.target as HTMLInputElement });
                    }}
                    feedback={
                        (validations.some(x => x) || isAutoManaged) && (
                            isAutoManaged ?
                                <Form.Text > {MessageAutoManager}</Form.Text> :
                                <Form.Control.Feedback type={GetFeedbackType(isValid)} children={message} />)
                    }
                    disabled={rest.disabled}
                />
            </Form.FloatingLabel>
        </Form.Group >
    )
}

export default FloatingCheck